<div class="row chart-config-color-line">
	{{#each colors}}
	<div class="col-sm-3 col-xs-4 m-b-5 color-select">
		{{#if custom}}
		<button type="button" class="btn js-custom-color m-t-10" style="background-color: {{color}}; color:white">
			<i class="fa fa-paint-brush"></i>
		</button>
		<div class="chart-colorpicker"></div>
		{{else}}
		<button type="button" class="btn js-normal-color" style="background-color: {{color}}; color:white">
			<i class="fa fa-paint-brush"></i>
		</button>
		{{/if}}
	</div>
	{{/each}}
</div>